<!--
 * @Author: DY
 * @Date: 2020-05-18 20:17:14
 * @LastEditTime: 2020-07-09 11:00:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_dev\src\views\reportForm\salesComponents\attachmentPreview.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="attachmentPreview">
            <HeaderNav
                v-if="isNews != true"
                header-title="附件预览"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: onClickLeft }"
            ></HeaderNav>
            <section>
                <iframe :src="src" frameborder="0"></iframe>
            </section>
        </div>
    </v-touch>
</template>
<script>
import { HeaderNav } from '@/components/';
export default {
    // 附件预览
    name: 'attachment-preview',
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            // 附件地址
            src: '',
            // 是否是消息跳转审批
            isNews: false,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.isNews = this.$route.params.isNews;
        this.src = this.$route.params.url;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus" scoped>
.attachmentPreview
    height 100%
    section
        height calc(100% - 45rpx)
        iframe
            width 100%
            height 100%
</style>